// import throttle from 'lodash/throttle'
import types from '@/store/mutation-types'
import store from '@/store'
// const restTimeout = throttle(function () {
//   store.commit(types.ADD_MINUTES)
// }, 60000) // 一分鐘更新
const response = {
  fulfilled: response => {
    // const memberInfo = store.getters['common/memberInfo']
    // const isLogin = memberInfo.login
    // if (isLogin) {
    //   restTimeout()
    // }
    if (response && response.request && response.request.responseURL &&
        response.request.responseURL.endsWith('RestApi/public/userInfo')) {
      // 略過這個request，不做reset timer
    } else {
      store.commit(types.RESET_TIMER)
    }
    return response
  },
  rejected: error => {
    const { config } = error
    const msg = `${config.method} : ${config.url}`
    const isDev = process.env.NODE_ENV === 'development'
    isDev && console.error(error, msg)

    if (config.url && config.url.includes('/kgib/rest/getKgibAddress')) {
      // 地址api，錯誤自己控制
      return Promise.resolve(
        {
          data: {
            connectError: true
          }
        }
      )
    }

    return Promise.reject(error)
  }
}
export default response
